import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15 6.25C15 7.86083 13.6942 9.16667 12.0833 9.16667C10.4725 9.16667 9.16667 7.86083 9.16667 6.25C9.16667 4.63917 10.4725 3.33333 12.0833 3.33333C13.6942 3.33333 15 4.63917 15 6.25Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.66962 7.48968C7.55911 7.09539 7.5 6.67959 7.5 6.25C7.5 4.5739 8.39969 3.10794 9.74248 2.3087C9.2427 1.90702 8.60775 1.66667 7.91667 1.66667C6.30584 1.66667 5 2.9725 5 4.58333C5 6.11096 6.17441 7.36428 7.66962 7.48968Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.1361 11.3166C12.1667 11.0494 12.0243 10.7763 11.7565 10.752C11.7516 10.7516 11.7468 10.7512 11.7419 10.7508L7.66391 10.4276C7.21405 10.392 6.76126 10.4436 6.333 10.5793L2.5 11.7943V17.5166H4.03192L4.04214 17.5197C4.13324 17.5478 4.26404 17.5872 4.42666 17.6337C4.75134 17.7264 5.20573 17.8478 5.72621 17.9634C6.74224 18.1889 8.10435 18.4139 9.2495 18.3051C10.4747 18.1887 11.9897 17.6132 13.2983 17.0196C14.634 16.4138 15.8615 15.7387 16.5429 15.3491C17.1513 15.0014 17.5 14.3801 17.5 13.7267C17.5 12.4385 16.2975 12.1298 15 12.5L12.9167 13.125C12.0833 14.1667 11.6256 14.4297 10.3126 14.7107L8.69411 15.057L8.41972 13.8973L10.0382 13.551C11.1679 13.3093 12.011 12.4113 12.1361 11.3166Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }